"use client";

import useToast from "@/stores/toast";
import { Alert, Snackbar } from "@mui/material";

export default function Toast() {
  const { open, handleClose, severity, message } = useToast();

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
}
